import { features } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section id="features" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            为什么选择6080影视
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            用技术和服务打造最好的免费追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-7 text-center group hover:border-primary-200/60 transition-colors"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}